import { Tooltip } from "@blueprintjs/core";
export default Tooltip;
